import React, { useEffect } from 'react';
import { AppBarCMS } from '../../../../basic';
import { routes } from '../../../../../utils/helpers/ApiClient';
import { useTranslation } from 'react-i18next';
import { SensorsTable } from './SensorsTable';
import {
  useDeleteSensorMutation,
  useGetSensorsQuery,
} from '../../../../../redux/services/sensors';
import { Spinner } from '../../../../common';
import { useNavigate } from 'react-router-dom';
import { useToastMessages } from '../../../../../hooks/useToastMessages';

export function SensorsPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { deleteSuccess: showDeleteSuccess } = useToastMessages();

  const { data: sensors, isLoading, refetch } = useGetSensorsQuery();
  const [deleteSensor, { isSuccess }] = useDeleteSensorMutation();

  useEffect(() => {
    if (isSuccess) {
      showDeleteSuccess();
      refetch();
    }
  }, [isSuccess]);

  return isLoading ? (
    <Spinner />
  ) : (
    <>
      <AppBarCMS
        title={'Správa senzorov'}
        backUrl={routes.cmsDashboard}
        backUrlTooltip={t('Nástenka')}
        permissionsBasic={'meteo-station'}
      />

      <div style={{ margin: '10px' }}>
        <SensorsTable
          sensors={sensors}
          onAttributesClick={(sensor) =>
            navigate(routes.cmsMeteoStationSensorsAttributes(sensor.id))
          }
          onPreviewClick={(sensor) =>
            navigate(routes.cmsMeteoStationSensorsDetail(sensor.id))
          }
          onEditClick={(sensor) =>
            navigate(routes.cmsMeteoStationSensorsEdit(sensor.id))
          }
          onDelete={(sensor) => deleteSensor(sensor.id)}
        />
      </div>
    </>
  );
}

export default SensorsPage;
